import PropTypes from 'prop-types';
import React, { Component } from 'react';
import get from 'lodash/get';
import noop from 'lodash/noop';
import Layout from 'yoda-site-components/lib/components/Layout/Layout';
import Loader from 'yoda-core-components/lib/components/Loader/Loader';
import makeQuery from 'yoda-core-components/lib/navigation/query/makeQuery';
import { syncAndGetCookieToken } from 'yoda-core-components/lib/helpers/Utils/Utils';
import { DP_USER_STATE } from 'yoda-site-components/lib/common/Constants';
import Helmet from 'react-helmet';
import Canonincalize from 'yoda-account-components/lib/components/Canonincalize/Canonincalize';
import { trackOrder } from 'yoda-account-components/lib/common/Constants';
import TrackOrders from './TrackOrders/TrackOrders';

class TrackOrderWrapper extends Component {
    static propTypes = {
        actions: PropTypes.objectOf(PropTypes.func).isRequired,
        trackOrder: PropTypes.objectOf(PropTypes.object).isRequired,
        preferences: PropTypes.objectOf(PropTypes.object).isRequired,
        featureFlags: PropTypes.objectOf(PropTypes.object).isRequired,
        messagesTexts: PropTypes.objectOf(PropTypes.object).isRequired,
        deviceType: PropTypes.shape({
            isDesktop: PropTypes.bool,
            isMobile: PropTypes.bool,
            isTablet: PropTypes.bool,
        }).isRequired,
        location: PropTypes.shape({
            pathname: PropTypes.string.isRequired,
            search: PropTypes.string.isRequired,
        }),
        accountAction: PropTypes.objectOf(PropTypes.func).isRequired,
        authenticationSuccess: PropTypes.bool,
        createAccountSuccess: PropTypes.bool,
        redirectAction: PropTypes.objectOf(PropTypes.func).isRequired,
        headers: PropTypes.objectOf.isRequired,
        analyticsAction: PropTypes.shape({
            triggerFormError: PropTypes.func,
        }),
    };

    static defaultProps = {
        location: {
            pathname: '/orders/trackorders',
            search: {},
        },
        authenticationSuccess: false,
        createAccountSuccess: false,
        analyticsAction: {
            triggerFormError: noop,
        },
    };

    /* istanbul ignore next */
    constructor(props) {
        super(props);
        const deviceType = props.deviceType.isDesktop ? 'desktop' : 'mobile';

        this.state = {
            deviceType,
        };
        this.trackOrder = this.trackOrder.bind(this);
    }

    /* eslint-disable camelcase */
    UNSAFE_componentWillMount() {
        if (__SERVER__) {
            const { headers, redirectAction, preferences, location } = this.props;
            const userState = get(headers, 'cookies.DP_USER_STATE', '0');

            if (userState !== '0') {
                // check if not guest user
                let redirectUrl;

                const query = makeQuery(location.search);
                const cid = query.cid ? `cid=${query.cid}` : '';

                if (cid) {
                    // Track order from Email click flow
                    let orderNumberValue = query.orderNumber || '';
                    const orderConfig = get(trackOrder, 'inputFields.orderNumber', {});
                    if (orderNumberValue) {
                        orderNumberValue = orderNumberValue.replace(orderConfig.onlyNum, '');
                    }
                    if (orderNumberValue && userState === '1') {
                        redirectUrl = `${preferences.navigateToOrderDetails}?id=${orderNumberValue}&${cid}`;
                    } else if (orderNumberValue && userState === '2') {
                        redirectUrl = `${preferences.navigateToOrders}?id=${orderNumberValue}`;
                    } else {
                        redirectUrl = `${get(preferences, 'navigateToOrders')}?${cid}`;
                    }
                } else {
                    // Track order when logged in through bookmark url flow
                    redirectUrl = get(preferences, 'navigateToOrders');
                }

                if (redirectUrl) redirectAction.setRedirectUrl({ url: redirectUrl });
            }
        }
    }

    componentDidMount() {
        this.validateUserStateAndRoute();
    }

    validateUserStateAndRoute = () => {
        const ordersUrl = '/orders';
        const userState = syncAndGetCookieToken(DP_USER_STATE) || '0';
        if (userState !== '0') {
            // DONT change to getBrowserHistory as it was observed as
            // redirect order--> trackorder--> order and so on
            window.location.assign(ordersUrl);
            return true;
        }
        return false;
    };

    trackOrder(trackOrderDetail) {
        const redirected = this.validateUserStateAndRoute();
        // if all good then only
        !redirected && this.props.actions.trackOrder(trackOrderDetail);
    }

    render() {
        const {
            trackOrder,
            featureFlags,
            preferences,
            messagesTexts,
            location,
            location: { pathname = '' },
            accountAction,
            authenticationSuccess,
            createAccountSuccess,
            actions,
            analyticsAction: { triggerFormError },
        } = this.props;
        const { deviceType } = this.state;
        const pageTitle = 'Track Orders - JCPenney';
        return (
            <Layout>
                {trackOrder.isLoading && (
                    <Loader keepOverlay automationId="test-automation-loader-1" />
                )}
                <Helmet title={pageTitle} />
                <Canonincalize urlLocation={pathname} />
                <TrackOrders
                    trackOrder={trackOrder}
                    submitHandler={this.trackOrder}
                    featureFlags={featureFlags}
                    preferences={preferences}
                    messagesTexts={messagesTexts}
                    deviceType={deviceType}
                    location={location}
                    accountAction={accountAction}
                    authenticationSuccess={authenticationSuccess}
                    createAccountSuccess={createAccountSuccess}
                    actions={actions}
                    triggerFormError={triggerFormError}
                />
            </Layout>
        );
    }
}

export default TrackOrderWrapper;
